// src/services/api.js
import axios from "axios";

// Create the Axios instance
const networkInstance = axios.create({
  baseURL: "https://elitewash.co.in/api/v1/",
  timeout: 5000, // Optional: timeout for requests
  headers: {
    "Content-Type": "application/json",
  },
});

networkInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle the error
  }
);

export default networkInstance;
